import { useId, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLanguage } from "../../context/LanguageContext";
import { Colors } from "../../styles/theme/index";
import styles from "./Accordion.styles";

const Accord = ({ title, content, variant = "default" }) => {
  const { selectedLanguage } = useLanguage();
  const isLanguageRTL = selectedLanguage === "ar";
  const directionStyle = isLanguageRTL ? { direction: "rtl" } : {};
  const isFAQ = variant === "faq";
  const [expanded, setExpanded] = useState(false);
  const panelId = useId();

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      sx={
        isFAQ
          ? { ...styles.Accordion_faqContainer, ...directionStyle }
          : { ...styles.Accordion_container, ...directionStyle }
      }
    >
      <AccordionSummary
        expandIcon={
          isFAQ ? (
            <Box sx={styles.Accordion_faqToggle}>
              {expanded ? <RemoveIcon /> : <AddIcon />}
            </Box>
          ) : (
            <ExpandMoreIcon sx={{ color: Colors.primary }} />
          )
        }
        aria-controls={`${panelId}-content`}
        id={`${panelId}-header`}
        sx={isFAQ ? styles.Accordion_faqSummary : undefined}
      >
        <Typography
          variant={isFAQ ? "body1" : "h6"}
          color={isFAQ ? Colors.navy : Colors.text}
          component="div"
          sx={isFAQ ? styles.Accordion_faqTitle : undefined}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        id={`${panelId}-content`}
        sx={isFAQ ? styles.Accordion_faqDetails : undefined}
      >
        <Typography
          variant="body1"
          color={Colors.text}
          component="div"
          sx={isFAQ ? styles.Accordion_faqContent : undefined}
        >
          {content}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default Accord;
